<template>
    <div class="landing-wrapper">
		<div class="spacer d-block d-md-none">
			<!-- Promotion Banner Mobile -->
			<slider-banner
				:is-loading="isFetching"
				:radius="false"
				:identity="'mobile'"
			/>
		</div>

		<div class="container">

			<div class="spacer d-none d-md-block mt-5">
				<!-- Promotion Banner Desktop -->
				<slider-banner
					:is-loading="isFetching"
					:identity="'desktop'"
					:additionalClass="'homepage'"
				/>
			</div>

			<div class="spacer" v-for="(section, index) in sections" :key="index">
				<component v-bind:is="section.type" :config="section.config" :meta="section.meta" :slug="section.slug" />
			</div>

			<!-- Type : Selling Point -->
			<!-- <div class="mb-5">
				<selling-point></selling-point>
			</div> -->

			<!-- Type : TopCategory -->
			<!-- <div class="mb-5">
				<top-category
					:is-loading="isFetching"
				/>
			</div> -->

			<!-- Type : Featured -->
			<!-- <div class="mb-5">
				<featured
					:title="'Top Produk'"
					:icon="'bi-tags'"
				/>
			</div> -->

			<!-- Type : Featured -->
			<!-- <div class="mb-5">
				<featured
					:title="'Produk Rekomendasi'"
					:icon="'bi-bag-check'"
				/>
			</div> -->

			<!-- Type : Kategori Produk -->
			<!-- <div class="mb-3">
				<product-category
					:title="'Kategori Produk'"
					:icon="'bi-cart-check'"
				/>
			</div> -->

			<!-- Type : Single Banner -->
			<!-- <div class="mb-5">
				<single-banner/>
			</div> -->

			<!-- Type : Selling Point With Text -->
			<!-- <div class="mb-5">
				<selling-point-with-text/>
			</div> -->
		</div>

		<main-footer></main-footer>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SliderBanner from '@/components/homepages/sections/SliderBanner.vue';
import SellingPoint from '@/components/homepages/sections/SellingPoint.vue';
import TopCategory from '@/components/homepages/sections/TopCategory.vue';
import Featured from '@/components/homepages/sections/Featured.vue';
import ProductCategory from '@/components/homepages/sections/ProductCategory.vue';
import SingleBanner from '@/components/homepages/sections/SingleBanner.vue';
import Suppliers from '@/components/homepages/sections/Suppliers.vue';
import SellingPointWithText from '@/components/homepages/sections/SellingPointWithText.vue';
import MainFooter from '@/components/homepages/Footer.vue';
import TwoColumnBanner from '@/components/homepages/sections/TwoColumnBanner.vue';
import FourColumnBanner from '@/components/homepages/sections/FourColumnBanner.vue';

import homepageApi from '@/api/homepage';

export default {
	name: 'Landing',
	components: {
		SliderBanner,
		SellingPoint,
		TopCategory,
		Featured,
		ProductCategory,
		SingleBanner,
		Suppliers,
		SellingPointWithText,
		MainFooter,
		TwoColumnBanner,
		FourColumnBanner,
	},
	data() {
		return {
			component: 'SingleBanner',
			isFetching: false,
			sections: [
				{
					id: 'a1788c8e-295e-4d33-af26-3df0044bd6d2',
					name: 'Product Category',
					slug: 'product-category',
					type: 'ProductCategory',
					meta: {
						title: 'Kategori Produk',
						icon: 'bi-bag-check',
						source: 'static',
					},
					description: 'Show category and 8 product list',
					canMultiple: false,
					config: [],
					text: 'Product Category',
					desc: 'Show category and 8 product list',
				},
				/* {
					id: '3c80f10e-b31c-409c-bc9f-a1b5d593f3ba',
					name: 'Top Product',
					slug: 'top-product',
					type: 'Featured',
					meta: {
						title: 'Top Produk',
						icon: 'bi-tags',
						source: 'static',
					},
					description: 'Show 4 top product based on sales',
					canMultiple: true,
					config: [],
					text: 'Top Product',
					desc: 'Show 4 top product based on sales',
				}, */
				{
					id: 'aa6d3828-b055-4736-9546-5a956eec3da9',
					name: 'Top Category',
					slug: 'top-category',
					type: 'TopCategory',
					meta: {
						title: 'Top Kategori',
						icon: 'bi-award',
						source: 'static',
					},
					description: 'Show 4 top category based on sales',
					canMultiple: true,
					config: [],
					text: 'Top Category',
					desc: 'Show 4 top category based on sales',
				},
			],
		};
	},
	methods: {
		...mapActions({
			getDropshipProductAdded: 'homepage/getDropshipProductAdded',
			getProductWishlistAdded: 'wishlist/getProductWishlistAdded',
		}),
		fetchSections() {
			this.isFetching = true;

			const params = {};

			const callback = (response) => {
				const responseData = response.data;
				this.sections = responseData.data.sections;
				this.isFetching = false;
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			homepageApi.getPublicSections(params, callback, errorCallback);
		},
		generateSessionId() {
			const sessionId = this.$uuid.v4();
			sessionStorage.setItem('sessionId', sessionId);
		},
	},
	computed: {
		...mapGetters({
			isOoLoggedIn: 'isOoLoggedIn',
		}),
	},
	created() {
		this.generateSessionId();
		this.fetchSections();
		if (this.isOoLoggedIn) {
			this.getDropshipProductAdded();
			this.getProductWishlistAdded();
		}
	},
	watch: {
		isOoLoggedIn(val) {
			if (val) {
				this.getDropshipProductAdded();
				this.getProductWishlistAdded();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
	// .landing-wrapper {
	// 	margin-top: 40px;
	// }

	.spacer {
		margin-bottom: 3rem;
		@media screen and (max-width: 540px) {
			margin-bottom: 20px;
		}
		.rounded-section{
			padding: 1.5rem;
				@media screen and (max-width: 540px) {
					padding-left: 0.5rem !important;
					padding-right: 0.5rem !important;
					padding-top: 1rem !important;
				}
		}
	}
	@media only screen and (max-width: 540px) {
		.container{
			padding: 0;
			margin: 0;
		}
		.four-column-banner {
			width: 100%;
			padding-right: 15px;
			padding-left: 15px;
			margin-right: auto;
			margin-left: auto;
		}
	}
</style>
